// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("sunny-meadow-landscape.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body .test1 {
  height: 100%;
}

body {
  font-family: 'Inter', sans-serif;
}

.prevent_scrolling {
  overflow: hidden !important;
}

body .test1 {
  display: flexbox;
  align-items: center;
  padding-top: 60px;
  padding-bottom: 40px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) top right no-repeat;
  background-size: cover;
}

body .test1:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right top, #060b3b, #00060b3b, #00060b3b);
  z-index: -1;
}

.color {
  background-color: #ffcd00;
  color: #060b3b;
}

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  padding-top: 8%;
  margin: auto;
}

.form-signin .checkbox {
  font-weight: 400;
}

.form-signin .form-floating:focus-within {
  z-index: 2;
}

.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.bd-placeholder-img {
  font-size: 1.125rem;
  text-anchor: middle;
  -webkit-user-select: none;
  user-select: none;
}

@media (min-width: 768px) {
  .bd-placeholder-img-lg {
    font-size: 3.5rem;
  }
}



/* CSS DEL COMPONENTE DE HEADER */

header {
  background-color: #FFFFFF;
  height: 80px;
  border-bottom: 1px solid #EBEBEB;
}

.nameExporter {
  color: #000000;
  font-size: 16px;
  font-weight: 700;
}

.logout {
  color: #858585;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

.b-example-divider {
  height: 3rem;
  background-color: rgba(0, 0, 0, .1);
  border: solid rgba(0, 0, 0, .15);
  border-width: 1px 0;
  box-shadow: inset 0 .5em 1.5em rgba(0, 0, 0, .1), inset 0 .125em .5em rgba(0, 0, 0, .15);
}

.color {
  background-color: #ffcd00;
  color: #060b3b;
  border: transparent;
}

.form-control-dark {
  color: #fff;
  background-color: var(--bs-dark);
  border-color: var(--bs-gray);
}

.form-control-dark:focus {
  color: #fff;
  background-color: var(--bs-dark);
  border-color: #fff;
  box-shadow: 0 0 0 .25rem rgba(255, 255, 255, .25);
}

.bi {
  vertical-align: -.125em;
  fill: currentColor;
}

.text-small {
  font-size: 85%;
}

.dropdown-toggle {
  outline: 0;
}

button {
  border: none;
  background-color: #96C24D;
}

.btn-color-ucropit {
  border: none !important;
  background-color: #96C24D;
}

.quill-description p {
  margin-bottom: auto;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;EAEE,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,uEAA+D;EAC/D,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,wEAAwE;EACxE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EAEzB,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;;;AAIA,iCAAiC;;AAEjC;EACE,yBAAyB;EACzB,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,gCAAgC;EAChC,mBAAmB;EACnB,wFAAwF;AAC1F;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["html,\nbody .test1 {\n  height: 100%;\n}\n\nbody {\n  font-family: 'Inter', sans-serif;\n}\n\n.prevent_scrolling {\n  overflow: hidden !important;\n}\n\nbody .test1 {\n  display: flexbox;\n  align-items: center;\n  padding-top: 60px;\n  padding-bottom: 40px;\n  background: url(sunny-meadow-landscape.jpg) top right no-repeat;\n  background-size: cover;\n}\n\nbody .test1:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(to right top, #060b3b, #00060b3b, #00060b3b);\n  z-index: -1;\n}\n\n.color {\n  background-color: #ffcd00;\n  color: #060b3b;\n}\n\n.form-signin {\n  width: 100%;\n  max-width: 330px;\n  padding: 15px;\n  padding-top: 8%;\n  margin: auto;\n}\n\n.form-signin .checkbox {\n  font-weight: 400;\n}\n\n.form-signin .form-floating:focus-within {\n  z-index: 2;\n}\n\n.form-signin input[type=\"email\"] {\n  margin-bottom: -1px;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.form-signin input[type=\"password\"] {\n  margin-bottom: 10px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.bd-placeholder-img {\n  font-size: 1.125rem;\n  text-anchor: middle;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n}\n\n@media (min-width: 768px) {\n  .bd-placeholder-img-lg {\n    font-size: 3.5rem;\n  }\n}\n\n\n\n/* CSS DEL COMPONENTE DE HEADER */\n\nheader {\n  background-color: #FFFFFF;\n  height: 80px;\n  border-bottom: 1px solid #EBEBEB;\n}\n\n.nameExporter {\n  color: #000000;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.logout {\n  color: #858585;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.b-example-divider {\n  height: 3rem;\n  background-color: rgba(0, 0, 0, .1);\n  border: solid rgba(0, 0, 0, .15);\n  border-width: 1px 0;\n  box-shadow: inset 0 .5em 1.5em rgba(0, 0, 0, .1), inset 0 .125em .5em rgba(0, 0, 0, .15);\n}\n\n.color {\n  background-color: #ffcd00;\n  color: #060b3b;\n  border: transparent;\n}\n\n.form-control-dark {\n  color: #fff;\n  background-color: var(--bs-dark);\n  border-color: var(--bs-gray);\n}\n\n.form-control-dark:focus {\n  color: #fff;\n  background-color: var(--bs-dark);\n  border-color: #fff;\n  box-shadow: 0 0 0 .25rem rgba(255, 255, 255, .25);\n}\n\n.bi {\n  vertical-align: -.125em;\n  fill: currentColor;\n}\n\n.text-small {\n  font-size: 85%;\n}\n\n.dropdown-toggle {\n  outline: 0;\n}\n\nbutton {\n  border: none;\n  background-color: #96C24D;\n}\n\n.btn-color-ucropit {\n  border: none !important;\n  background-color: #96C24D;\n}\n\n.quill-description p {\n  margin-bottom: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
